import { render, staticRenderFns } from "./transaction-defaults-index.vue?vue&type=template&id=262495e8"
import script from "./transaction-defaults-index.vue?vue&type=script&lang=js"
export * from "./transaction-defaults-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports